import React, { useState } from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";

interface CancelCustomerApplicationConfirmModalProps {
    confirm: () => Promise<void>
    cancel: () => void
}

export function CancelCustomerApplicationConfirmModal(props: CancelCustomerApplicationConfirmModalProps) {

    const [loading, setLoading] = useState(false);

    const onConfirm = async () => {
        setLoading(true);
        await props.confirm();
        setLoading(false);
    }

    return (
        <>
            <Modal
                show={true}
                size={"lg"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={props.cancel}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Taotluse tühistamine
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="">
                        Kas oled kindel, et soovid taotluse tühistada?
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="outline-dark"
                            onClick={props.cancel}
                            disabled={loading}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Loobu</span>
                    </Button>
                    <Button 
                        variant="danger"
                        onClick={onConfirm}
                        disabled={loading}
                        type="button"
                        className="d-flex align-items-center"
                    >
                        <span className='px-2'>{ loading ? <Spinner animation='border' className='mr-2' /> : false } Tühista taotlus</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
